export const selectFirebaseData = (s: any) => s.firestore.data
